import { Navigate } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { useAuthStore } from '@/store/authStore'
import { hrApi } from '@/services/api/hr'

export function HRHomePage() {
  const role = useAuthStore(s => s.user?.role)
  const { data, isLoading } = useQuery({
    queryKey: ['hr-my-scopes'],
    queryFn: () => hrApi.getMyScopes(),
    staleTime: 5 * 60 * 1000,
    retry: false,
    enabled: role === 'hr',
  })

  if (role !== 'hr') {
    return <Navigate to="/hr/pult" replace />
  }

  if (data?.module_enabled === true) {
    return <Navigate to="/hr/pult" replace />
  }

  if (isLoading) {
    return <div className="p-6 text-gray-500">Laden...</div>
  }

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-2">HR</h1>
      <p className="text-sm text-gray-600">Das HR-Modul ist für diese Schule nicht aktiv.</p>
    </div>
  )
}
